export function Header() {
  return (
    <header className="mb-8 -mx-6 sm:-mx-12 lg:-mx-8 px-6 sm:px-12 lg:px-8">
      <h1
        className="text-5xl sm:text-6xl font-semibold tracking-tight -ml-1"
        style={{ fontFamily: "Space Mono, monospace" }}
      >
        fermi
      </h1>
      <p className="text-lg text-white/60 max-w-md leading-relaxed">
        utvikling & design
      </p>
    </header>
  );
}
